// eslint-disable-next-line import/no-anonymous-default-export,react/display-name
export default function ({ image, ...props }) {
  if (typeof image === "string") {
    return <img src={image} title="" alt="" {...props} />;
  }

  if (typeof image === "object" && image !== null) {
    return <img src={image?.url} alt={image.alt} title={image.title} {...props} />;
  }

  return null;
}
